<template>
  <div id="BrandUsageList" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>爬虫执行情况</el-breadcrumb-item>
      <el-breadcrumb-item>品牌用量价格</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;" :label-width="formLabelWidth">
        <el-form-item label="日期">
          <el-date-picker v-model="searchformDate" type="daterange" start-placeholder="开始日期" value-format="yyyy-MM-dd"
            end-placeholder="结束日期" range-separator="~" size="small">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="品牌">
          <el-select v-model="queryParams.bmcids" placeholder="请选择" multiple clearable filterable size="small">
            <el-option
									v-for="item in dataOptions"
									:key="item.bmcid"
									:label="item.companyname"
									:value="item.bmcid">
								</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台">
          <el-select v-model="queryParams.platform" placeholder="请选择" multiple clearable size="small">
            <el-option key="淘宝" label="淘宝" value="淘宝"></el-option>
            <el-option key="京东" label="京东" value="京东"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务来源">
          <el-select v-model="queryParams.function" placeholder="请选择" clearable size="small">
            <el-option key="商品数据库" label="商品数据库" value="商品数据库"></el-option>
            <el-option key="快速入库" label="快速入库" value="快速入库"></el-option>
            <el-option key="违规检索" label="违规检索" value="违规检索"></el-option>
            <el-option key="插件系统刷新" label="插件系统刷新" value="插件系统刷新"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务商">
          <el-select v-model="queryParams.provider" placeholder="请选择" clearable size="small">
            <el-option key="求美" label="求美" value="求美"></el-option>
            <el-option key="喜大" label="喜大" value="喜大"></el-option>
            <el-option key="悠悠乐" label="悠悠乐" value="悠悠乐"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
        </el-form-item>
      </el-form>
    </section>
    <div class="page">
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="品牌名称" prop="bmcname">
        </el-table-column>
        <el-table-column label="日期" prop="createtime">
          <template slot-scope="scope">
            {{ scope.row.createtime | fullTimeShort }}
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="platform">
        </el-table-column>
        <el-table-column label="任务来源" prop="function">
        </el-table-column>
        <el-table-column label="服务商" prop="provider">
        </el-table-column>
        <el-table-column label="费用" prop="sumprice">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryParams: {
        bmcids: [],
        platform: [],
        function: '',
        provider: ''
      },
      dataOptions: [],
      searchformDate: [],
      formLabelWidth: '120px',
      tableData: [],
    }
  },
  mounted() {
    this.getAllUseBmainCustomer();
  },
  methods: {
    theQuery() {
      let params = {}
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.starttime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10)
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10)
      } else {
        this.$message({
          message: '请先选择日期',
          type: 'warning'
        });
        return
      }
      if (this.queryParams.bmcids.length > 0) {
        params.bmcids = this.queryParams.bmcids.join(',')
      }
      if (this.queryParams.platform.length > 0) {
        params.platform = this.queryParams.platform.join(',')
      }
      if (this.queryParams.function) {
        params.function = this.queryParams.function
      }
      if (this.queryParams.provider) {
        params.provider = this.queryParams.provider
      }
      
      fetch({
        url: "hcm/iprBmcTotalCount/getList",
        method: "post",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          console.log(data)
          this.tableData = data;
        }
      }).catch(err => {

      })
    },
    getAllUseBmainCustomer() {
      fetch({
        url: "hcm/cus/getAllUseBmainCustomer",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          console.log(data)
          this.dataOptions = data;
        }
      }).catch(err => {

      })
    }
  },
  components: {}
}
</script>
<style scoped lang="scss">
.page {
  padding: 20px;
  margin-top: 10px;
  background-color: white;
}
</style>
<style lang="scss">
#BrandUsageList {
  .el-table th {
    background-color: #f3f7ff !important;
  }

  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }

  .el-button+.el-button {
    margin-left: 1px;
  }

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }

  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }

  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
}
</style>
